/*
*   File:           use-postapplog.hook.ts
*   Description:    Use this for selectively record logs in the app-server.logs file 
*                   Calls post/log in app_server.py in daemon to write to the production build log file
*/
import { useCallback } from "react";
import { postAppLog, AppConfiguration } from "src/common";

export function usePostAppLog() {
    // Description: send the log to a file that will be downloaded with all the other PV logs.
    const log = useCallback(async (log: unknown, level: string = "info") => {
        console.log(`%cPreveil Logger: [${level}]`, "color:black;font-size: 16px; font-weight: bold;", log);
        // Log data to the server
        const data = {
            level,
            message: typeof log === "object" ? JSON.stringify(log) : log
        };

        // NOTE: LOG to keymenu file or if in dev log to console
        (AppConfiguration.isDevelopmentRunMode() || AppConfiguration.buildForApp()) &&
            await postAppLog(data);
    }, []);

    return {
        log
    };
}
